import React, { useState, useEffect } from "react";
import Button3 from "../Buttons/Button3";
import Section from "./Sidebar-section";
import MultiRangeSlider from "../double range slider/MultiRangeSlider";
import { amenityIconFilterClass } from "../../utils/amenityIcon";

const Sidebar = ({ amenities, query, setQuery }) => {
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(500000);
  const [minRating, setMinRating] = useState(0);
  const [maxRating, setMaxRating] = useState(10);
  const [prePaymentPolicy, setPrePaymentPolicy] = useState("");
  const [cancellationPolicy, setCancellationPolicy] = useState("");
  const [breakfast, setBreakfast] = useState(false);
  const [lunch, setLunch] = useState(false);
  const [dinner, setDinner] = useState(false);
  const [ratingFlag, setRatingFlag] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [cancellationFlag, setCancellationFlag] = useState([
    false,
    false,
    false,
  ]);
  const cancellationPolicies = [
    "Free Upto 28 Days",
    "Free Upto 14 Days",
    "Non-refundable",
  ];
  const prePaymentPolicies = [
    "30%",
    "40%",
    "50%",
    "60%",
    "70%",
    "80%",
    "90%",
    "100%",
  ];
  const [paymentFlag, setPaymentFlag] = useState(
    Array(prePaymentPolicies.length).fill(false)
  );

  const [amenitiesFlag, setAmenitiesFlag] = useState(
    Array(amenities.length).fill(false)
  );

  // To handle the click of clear filters button
  const handleClear = () => {
    setMinPrice(0);
    setMaxPrice(50000);
    setMinRating(0);
    setMaxRating(10);
    setPrePaymentPolicy("");
    setCancellationPolicy("");
    setBreakfast(false);
    setLunch(false);
    setDinner(false);
    setAmenitiesFlag(Array(amenities.length).fill(false));
    setPaymentFlag(Array(prePaymentPolicies.length).fill(false));
    setCancellationFlag(Array(3).fill(false));
    setRatingFlag(Array(5).fill(false));
  };

  // Generates the query string based on state variables
  const formQuery = () => {
    let queryString = "";
    if (cancellationPolicy) {
      const selected = Array.isArray(cancellationPolicy)
        ? cancellationPolicy[0]
        : cancellationPolicy;
      if (selected === "Free Upto 28 Days") {
        queryString += `&cancellation_policy=FREE_UPTO_28_DAYS`;
      } else if (selected === "Free Upto 14 Days") {
        queryString += `&cancellation_policy=FREE_UPTO_14_DAYS`;
      } else if (selected === "Non-refundable") {
        queryString += `&cancellation_policy=NON_REFUNDABLE`;
      } else if (selected === "Free Upto 7 Days") {
        queryString += `&cancellation_policy=FREE_UPTO_7_DAYS`;
      } else if (selected === "Free Upto 48 Hours") {
        queryString += `&cancellation_policy=FREE_UPTO_48_HOURS`;
      }
    }
    queryString += `&min_a2z_score=${minRating * 10}&max_a2z_score=${
      maxRating * 10
    }`;
    if (breakfast) queryString += `&is_breakfast=${breakfast}`;
    if (lunch) queryString += `&is_lunch=${lunch}`;
    if (dinner) queryString += `&is_dinner=${dinner}`;
    queryString += `&min_price_guest_pay=${minPrice}&max_price_guest_pay=${maxPrice}`;
    queryString += `&page_size=20`;
    let amenitiesQuery = "&amenities=";
    let amenitiesQuery2 = amenitiesQuery;
    amenities.forEach((item, i) => {
      if (amenitiesFlag[i]) {
        amenitiesQuery += `${item.id}+`;
      }
    });
    if (amenitiesQuery !== amenitiesQuery2)
      amenitiesQuery = amenitiesQuery.slice(0, -1);
    queryString += amenitiesQuery;

    if (prePaymentPolicy !== "") {
      let preTemp = `&prepayment=`;
      preTemp += prePaymentPolicy.slice(0, -1);
      queryString += preTemp;
    }

    return queryString;
  };

  useEffect(() => {
    let temp = formQuery();
    //console.log("Inside here!");
    //console.log(temp);
    setQuery(temp);
  }, [amenities]);

  // Handles the click of apply filters button and updates the query string
  const handleApply = () => {
    let temp = formQuery();
    // //console.log(temp);
    setQuery(temp);
    //console.log("Final query .......", query);
  };

  // Handles the checking and unchecking of rating checkboxes
  const handleCheck = (ind) => {
    setRatingFlag((prevArray) => {
      const newArray = Array(5).fill(false);
      newArray[ind] = !prevArray[ind];
      return newArray;
    });
  };

  // to update the state variables of rating
  useEffect(() => {
    if (ratingFlag.every((val) => !val)) {
      setMinRating(0);
      setMaxRating(10);
    } else {
      const ind = ratingFlag.findIndex((val) => val === true);
      setMinRating((4 - ind + 1) * 2 - 1);
      setMaxRating((4 - ind + 1) * 2);
    }
  }, [ratingFlag]);

  // Handles the checking and unchecking of prepayment policy checkboxes
  const handlePayment = (ind) => {
    setPaymentFlag((prevArray) => {
      const newArray = Array(prePaymentPolicies).fill(false);
      newArray[ind] = !prevArray[ind];
      return newArray;
    });
  };

  // to update the state variables of prepayment policy
  useEffect(() => {
    if (paymentFlag.every((val) => !val)) {
      setPrePaymentPolicy("");
    } else {
      const ind = paymentFlag.findIndex((val) => val === true);
      setPrePaymentPolicy(prePaymentPolicies[ind]);
    }
  }, [paymentFlag]);

  // Handles the checking and unchecking of cancellation policy checkboxes
  const handleCancellation = (ind) => {
    setCancellationFlag((prevArray) => {
      const newArray = Array(3).fill(false);
      newArray[ind] = !prevArray[ind];
      return newArray;
    });
  };

  // to update the state variables of cancellation policy
  useEffect(() => {
    if (cancellationFlag.every((val) => !val)) {
      setCancellationPolicy("");
    } else {
      const ind = cancellationFlag.findIndex((val) => val === true);
      setCancellationPolicy([cancellationPolicies[ind]]);
    }
  }, [cancellationFlag]);

  const handleAmenities = (i) => {
    setAmenitiesFlag((prevArray) => {
      const newArray = [...prevArray];
      newArray[i] = !newArray[i];
      return newArray;
    });
  };

  return (
    //18px
    <>
      <aside className=" w-[300px] bg-[#f5f1f1] shadow-xl shadow-shadowColor h-fit mt-10  pt-4 ml-[48px]">
        <div className="grid grid-cols-2">
          <h1 className="text-txtColor font-semibold text-[24px] ml-8 ">
            Filter
          </h1>
          <div className="grid grid-cols-2 font-hk">
            <div
              className="ml-4"
              onClick={() => {
                handleApply();
              }}
            >
              <Button3 value={"Apply"} />
            </div>
            <div
              className="ml-2"
              onClick={() => {
                handleClear();
              }}
            >
              <Button3 value={"Clear"} />
            </div>
          </div>
        </div>
        <div className="divide-y divide-borderColor flex flex-col">
          <div className=" mb-3">
            <h3 className="text-[20px] text-txtColor font-semibold my-2 font-sans ml-8">
              Popular Amenities
            </h3>
            <ul className=" space-y-2">
              {amenities?.map((item, i) => (
                <li>
                  <div className="flex flex-row ml-8  font-sans font-medium text-txtColor text-[15px]">
                    <input
                      type="checkbox"
                      onChange={() => {
                        handleAmenities(i);
                      }}
                      checked={amenitiesFlag[i]}
                      class="accent-btnColor"
                      className="mr-3 h-[15px] w-[15px] accent-black"
                    />
                    {item.name === "Please Wait..." ? (
                      <i className="fa-solid fa-spinner"></i>
                    ) : (
                      <img
                        src={item.icon.file}
                        alt={item.name}
                        className={`w-[20px] h-[20px] object-contain ${amenityIconFilterClass(item.name)}`}
                      />
                    )}

                    <span className="ml-4">{item.name}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className=" mb-3">
            <h3 className="text-[20px] text-txtColor font-semibold my-2 font-sans ml-8">
              Price Range
            </h3>
            <ul className="">
              <MultiRangeSlider
                min={0}
                max={500000}
                onChange={({ min, max }) => {
                  setMinPrice(min);
                  setMaxPrice(max);
                  // //console.log(`min = ${minPrice}, max = ${maxPrice}`);
                }}
              />
            </ul>
          </div>

          <div className=" mb-3">
            <h3 className="text-[20px] text-txtColor font-semibold my-2 font-sans ml-8">
              Rating
            </h3>
            <ul className="">
              {ratingFlag.map((item, i) => {
                return (
                  <li>
                    <div className=" ml-8 font-sans font-medium text-txtColor text-[15px]">
                      <input
                        type="checkbox"
                        onChange={() => {
                          handleCheck(i);
                        }}
                        checked={ratingFlag[i]}
                        class="accent-btnColor"
                        className="mr-3 h-[15px] w-[15px] accent-black"
                      />
                      {(4 - i + 1) * 2} - {(4 - i + 1) * 2 - 1}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className=" mb-3">
            <h3 className="text-[20px] text-txtColor font-semibold my-2 font-sans ml-8">
              Prepayment Policy
            </h3>
            <ul className="">
              {prePaymentPolicies.map((item, i) => {
                return (
                  <li>
                    <div className=" ml-8 font-sans font-medium text-txtColor text-[15px]">
                      <input
                        type="checkbox"
                        onChange={() => {
                          handlePayment(i);
                        }}
                        checked={paymentFlag[i]}
                        class="accent-btnColor"
                        className="mr-3 h-[15px] w-[15px] accent-black"
                      />
                      {item}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className=" mb-3">
            <h3 className="text-[20px] text-txtColor font-semibold my-2 font-sans ml-8">
              Cancellation Policy
            </h3>
            <ul className="">
              {cancellationPolicies.map((item, i) => {
                return (
                  <li>
                    <div className=" ml-8 font-sans font-medium text-txtColor text-[15px]">
                      <input
                        type="checkbox"
                        onChange={() => {
                          handleCancellation(i);
                        }}
                        checked={cancellationFlag[i]}
                        class="accent-btnColor"
                        className="mr-3 h-[15px] w-[15px] accent-black"
                      />
                      {item}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className=" mb-3">
            <h3 className="text-[20px] text-txtColor font-semibold my-2 font-sans ml-8">
              Meals included
            </h3>
            <ul className="">
              <li>
                <div className=" ml-8 font-sans font-medium text-txtColor text-[15px]">
                  <input
                    type="checkbox"
                    checked={breakfast}
                    onChange={() => {
                      let temp = breakfast;
                      setBreakfast(!temp);
                    }}
                    className="mr-3 h-[15px] w-[15px] accent-black"
                  />
                  Breakfast
                </div>
              </li>
              <li>
                <div className=" ml-8 font-sans font-medium text-txtColor text-[15px]">
                  <input
                    type="checkbox"
                    checked={lunch}
                    onChange={() => {
                      let temp = lunch;
                      setLunch(!temp);
                    }}
                    className="mr-3 h-[15px] w-[15px] accent-black"
                  />
                  Lunch
                </div>
              </li>
              <li>
                <div className=" ml-8 font-sans font-medium text-txtColor text-[15px]">
                  <input
                    type="checkbox"
                    checked={dinner}
                    onChange={() => {
                      let temp = dinner;
                      setDinner(!temp);
                    }}
                    className="mr-3 h-[15px] w-[15px] accent-black"
                  />
                  Dinner
                </div>
              </li>
            </ul>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
